export default __webpack_public_path__ + "static/illustration1_w-0267afcc285ce9358ed1090ce2ced8a1.jpg";